import { render } from "./ServiceCodes.vue?vue&type=template&id=47a6852e"
import script from "./ServiceCodes.vue?vue&type=script&lang=ts"
export * from "./ServiceCodes.vue?vue&type=script&lang=ts"
script.render = render

export default script